export enum FeedbackAction {
    Create = 1,
    Respond
}
